import { AnimatePresence, m } from "motion/react";
import { useLocation, useOutlet } from "react-router";

/**
 * The layout's <Outlet />, faded and lifted in on every route change. Keyed by
 * pathname only, so filters and tabs held in search params swap in place
 * instead of replaying the page entrance.
 */
export function AnimatedOutlet({ className }: { className?: string }) {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <AnimatePresence mode="wait">
      <m.div
        key={location.pathname}
        className={className}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.15, ease: [0.25, 0.1, 0.25, 1] }}
      >
        {outlet}
      </m.div>
    </AnimatePresence>
  );
}
